import React from 'react';
import { motion } from 'framer-motion';
import { Save, X, Brain } from 'lucide-react';

interface JournalExitDialogProps {
  onClose: () => void;
  onContinue: () => void;
  onDismiss: () => void;
}

export function JournalExitDialog({ onClose, onContinue, onDismiss }: JournalExitDialogProps) {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[9999] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="theme-card p-6 max-w-sm w-full mx-4 relative"
      >
        <div className="relative space-y-4">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="relative">
              <Brain className="w-12 h-12 text-primary animate-pulse" />
              <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full" />
            </div>
          </div>

          {/* Title and Description */}
          <div className="text-center space-y-2">
            <h3 className="text-xl font-semibold">Save Your Progress?</h3>
            <p className="text-sm text-muted-foreground">
              Your brain's reward system strengthens with each completed entry! Would you like to save your progress?
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-2">
            <button
              onClick={onContinue}
              className="w-full theme-button py-3 rounded-lg flex items-center justify-center gap-2"
            >
              <Save className="w-4 h-4" />
              Save Progress
            </button>
            <button
              onClick={onDismiss}
              className="w-full bg-destructive/20 text-destructive hover:bg-destructive/30 transition-colors py-3 rounded-lg"
            >
              Discard Changes
            </button>
            <button
              onClick={onClose}
              className="w-full bg-muted hover:bg-muted/70 transition-colors py-3 rounded-lg"
            >
              Continue Editing
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}